import { getRouteApi } from "@tanstack/react-router";
import type { FC } from "react";

import { EmailDetailPage } from "@/pages/channels/pages/detail/email";
import { FacebookDetailPage } from "@/pages/channels/pages/detail/facebook";
import { InstagramDetailPage } from "@/pages/channels/pages/detail/instagram";
import { LineDetailPage } from "@/pages/channels/pages/detail/line";
import { WccsDetailPage } from "@/pages/channels/pages/detail/wccs";
import { WhatsappDetailPage } from "@/pages/channels/pages/detail/whatsapp";

const route = getRouteApi("/channels/$type/$id");

export const ChannelDetailPage: FC = () => {
  const { type } = route.useParams();

  if (type === "wccs") {
    return <WccsDetailPage />;
  }

  if (type === "whatsapp") {
    return <WhatsappDetailPage />;
  }

  if (type === "fb") {
    return <FacebookDetailPage />;
  }

  if (type === "ig") {
    return <InstagramDetailPage />;
  }

  if (type === "line") {
    return <LineDetailPage />;
  }

  if (type === "email") {
    return <EmailDetailPage />;
  }

  return null;
};
